/** Turns a stored string[] (or scalar) into a comma-separated string for editing. */
export function joinList(value: unknown): string {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  return value == null ? '' : String(value);
}

/** Splits a comma-separated edit string back into a trimmed, non-empty string[]. */
export function splitList(value: string | null | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

/** Normalizes a draft date to the `YYYY-MM-DD` form a native date input expects. */
export function normalizeDate(value: unknown): string {
  return typeof value === 'string' ? value.slice(0, 10) : '';
}
